// @ts-nocheck
/* eslint-disable @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-unused-vars, prettier/prettier */
import * as Types from './generated/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type FeatureGateCtaFieldsFragment = { __typename?: 'Cta', label: string, action: Types.DashboardActionType, value: string };

export type FeatureGateImageFieldsFragment = { __typename?: 'ColorModeImage', light: string, dark: string };

export type FeatureGateFieldsFragment = { __typename?: 'FeatureGate', title: string, description: string, cta?: { __typename?: 'Cta', label: string, action: Types.DashboardActionType, value: string } | null, image?: { __typename?: 'ColorModeImage', light: string, dark: string } | null };

export type FeatureGateQueryVariables = Types.Exact<{
  portalType: Types.PortalType;
  portalEntityId: Types.Scalars['ID']['input'];
  featureKey: Types.FeatureKey;
}>;


export type FeatureGateQuery = { __typename?: 'Query', featureGate?: { __typename?: 'FeatureGate', title: string, description: string, cta?: { __typename?: 'Cta', label: string, action: Types.DashboardActionType, value: string } | null, image?: { __typename?: 'ColorModeImage', light: string, dark: string } | null } | null };

export const FeatureGateCtaFieldsFragmentDoc = gql`
    fragment FeatureGateCtaFields on Cta {
  label
  action
  value
}
    `;
export const FeatureGateImageFieldsFragmentDoc = gql`
    fragment FeatureGateImageFields on ColorModeImage {
  light
  dark
}
    `;
export const FeatureGateFieldsFragmentDoc = gql`
    fragment FeatureGateFields on FeatureGate {
  title
  description
  cta {
    ...FeatureGateCtaFields
  }
  image {
    ...FeatureGateImageFields
  }
}
    ${FeatureGateCtaFieldsFragmentDoc}
${FeatureGateImageFieldsFragmentDoc}`;
export const FeatureGateDocument = gql`
    query featureGate($portalType: PortalType!, $portalEntityId: ID!, $featureKey: FeatureKey!) {
  featureGate(
    portalType: $portalType
    portalEntityId: $portalEntityId
    featureKey: $featureKey
  ) {
    ...FeatureGateFields
  }
}
    ${FeatureGateFieldsFragmentDoc}`;

/**
 * __useFeatureGateQuery__
 *
 * To run a query within a React component, call `useFeatureGateQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeatureGateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeatureGateQuery({
 *   variables: {
 *      portalType: // value for 'portalType'
 *      portalEntityId: // value for 'portalEntityId'
 *      featureKey: // value for 'featureKey'
 *   },
 * });
 */
export function useFeatureGateQuery(baseOptions: Apollo.QueryHookOptions<FeatureGateQuery, FeatureGateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FeatureGateQuery, FeatureGateQueryVariables>(FeatureGateDocument, options);
      }
export function useFeatureGateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FeatureGateQuery, FeatureGateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FeatureGateQuery, FeatureGateQueryVariables>(FeatureGateDocument, options);
        }
export type FeatureGateQueryHookResult = ReturnType<typeof useFeatureGateQuery>;
export type FeatureGateLazyQueryHookResult = ReturnType<typeof useFeatureGateLazyQuery>;
export type FeatureGateQueryResult = Apollo.QueryResult<FeatureGateQuery, FeatureGateQueryVariables>;